import { ModalOptions } from 'ngx-bootstrap/modal/modal-options.class';

export const ModalConfig: ModalOptions<any> = {
	ignoreBackdropClick: true,
	ariaLabelledBy: 'modal-cnt__tl'
};
